import { Voter } from "@activecollab/security";
import moment from "moment-timezone";
import { isFinancialManager } from "~/utils/userHelper";

export class TimesheetVoter extends Voter {
  attributes = ["add_time_record"];
  supports(attribute, subject) {
    if (subject.user && typeof subject.projectId === "number" && subject.timestamp && subject.context) {
      return this.attributes.includes(attribute);
    }
    return false;
  }

  voteOnAttribute(attribute, subject, user) {
    switch (attribute) {
      case "add_time_record": {
        if (user.class === "Client") {
          return false;
        }
        const subjectUser = this.state.users.get(`${subject.user}`);
        if (!subjectUser) {
          return false;
        }
        if (subjectUser.class === "Client") {
          return false;
        }
        if (subject.context === "Project" || subject.context === "MyWork") {
          if (user.class === "Owner" || isFinancialManager(user)) {
            return true;
          }
          const project = this.state.projects.get(`${subject.projectId}`);
          if (project && project.leader_id === user.id) {
            return true;
          }
          if (user.class === "Member" && subject.user !== user.id) {
            return false;
          }
          const backtrackMaxDays = this.state.config_options.get("backtrack_time_max_days", 30);
          const maxDaysAgo = moment().subtract(backtrackMaxDays, "days");
          return moment.unix(subject.timestamp).isAfter(maxDaysAgo);
        }
        if (subject.context === "Timesheet") {
          if (user.id === subject.user) {
            return true;
          }
        }
      }
    }
  }
}
